import { Button, Grid, makeStyles, MenuItem, TextField } from '@material-ui/core';
import { Search } from '@material-ui/icons';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import UniDialog from '../Common/UniDialog';
import _ from 'lodash';
import { DataGrid } from '@material-ui/data-grid';
import { useDispatch, useSelector } from 'react-redux';
import { getBranchById } from '../../utilities/common';
import ErrorIcon from '@material-ui/icons/Error';
import { showAlertSnackbar } from '../../reducers/uiSlice';
import { printOrderLabel } from '../../actions/orderExchangeActions';
import FullscreenLoading from '../Common/FullscreenLoading';


export default function BatchDetails(props) {
    const {t} = useTranslation('orderForwardTool');
    const dispatch = useDispatch();

    const statuses = [
        {
            id: '-1',
            text: t('common:all')
        },
        {
            id: '0',
            text: t('pending')
        },
        {
            id: '1',
            text: t('order_placed')
        },
        {
            id: '2',
            text: t('failed_to_forward')
        },
    ]

    const columns = [
        {field: 'id', hide: true},
        {
            field: 'tno', 
            headerName: t('tracking_no'), 
            flex: 1,
            headerAlign: 'center',
            alignItems: 'center',
            align: 'center',
            sortable: false
        },
        {
            field: 'warehouse', 
            headerName: t('warehouse'), 
            flex: 1,
            headerAlign: 'center',
            alignItems: 'center',
            align: 'center',
            sortable: false,
            valueFormatter: (params) => getBranchById(params.value).name,
            align: 'center'
        },
        {
            field: 'second_delivery_sn', 
            headerName: t('third_party_tracking_no'), 
            flex: 1,
            headerAlign: 'center',
            alignItems: 'center',
            align: 'center',
            sortable: false
        },
        {
            field: 'status', 
            headerName: t('status'), 
            flex: 1,
            headerAlign: 'center',
            alignItems: 'center',
            align: 'center',
            sortable: false,
            renderCell: (params) => (
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <span>{props.statuses[params.value + '']?.text || params.value}</span>
                    {
                        params.row.status + '' === '3' &&
                        <span><ErrorIcon style={{color: 'red', marginLeft: 5}}/></span>
                    }
                </div>
            )
        },
        {
            field: 'actions', 
            headerName: t('actions'), 
            flex: 1,
            headerAlign: 'center',
            alignItems: 'center',
            align: 'center',
            sortable: false,
            renderCell: (params) => (
                <Button
                    disabled={params.row.status + '' !== '2'}
                    onClick={() => {
                        setLoading(true);
                        dispatch(printOrderLabel({
                            tracking_number: params.row.second_delivery_sn
                        }))
                        .catch(() => {
                            showAlertSnackbar({message: t('print_fail'), type: 'error'})
                        })
                        .finally(() => {
                            setLoading(false);
                        })
                    }}
                    color='primary'
                >
                    {t('print')}
                </Button>
            )
        }
    ]


    const detailList = useSelector(state => state.orderExchangeReducer.queryTaskDetail);


    const [trackingNo, setTrackingNo] = useState();
    const [outsourceTrackingNo, setOutsourceTrackingNo] = useState();
    const [statusFilter, setStatusFilter] = useState('-1');
    const [detailListFilter, setDetailListFilter] = useState(detailList);
    const [loading, setLoading] = useState(false);


    const createRows = () => {
        return detailListFilter.map((row) => {
            const {...rest} = row
            return {...rest}
        })
    }

    const handleFilter = () => {
        const filterList = _.filter(detailList, (detail) => {
            return (
                (trackingNo ? detail.tno === trackingNo : true) 
                &&
                (outsourceTrackingNo ? detail.second_delivery_sn === outsourceTrackingNo : true) 
                &&
                (statusFilter !== '-1' ? detail.status === statusFilter : true)
            )
        })
        setDetailListFilter(filterList);
    }


    useEffect(() => {
        setDetailListFilter(detailList);
    }, [detailList])


    return (
        <>
            <UniDialog
                title={props.taskName}
                maxWidth='lg'
                open={props.open}
                onClose={props.handleClose}
                fullWidth
                disableDefaultButtons
            >
                <Grid container spacing={2} style={{display:'flex',alignItems:'center'}}>
                    <Grid item xs={3} style={{display:'flex',alignItems:'center'}}>
                        <TextField
                            label={t('tracking_no')}
                            value={trackingNo}
                            onChange={(e)=>setTrackingNo(e.target.value)}
                            variant='outlined'
                            fullWidth
                            id='orderforwardtool-batchdetail-tracking-textfield'
                        />
                    </Grid>
                    <Grid item xs={3} style={{display:'flex',alignItems:'center'}}>
                        <TextField
                            label={t('third_party_tracking_no')}
                            value={outsourceTrackingNo}
                            onChange={(e)=>setOutsourceTrackingNo(e.target.value)}
                            variant='outlined'
                            fullWidth
                            id='orderforwardtool-batchdetail-outsourcetracking-textfield'
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField 
                            id='orderforwardtool-batchdetail-status-textfield'
                            select
                            label={t('status')}
                            value={statusFilter}
                            onChange={(e)=>setStatusFilter(e.target.value)}
                            fullWidth
                            variant="outlined"
                        >
                            {
                                statuses.map((status) => (
                                    <MenuItem 
                                        key={status.id} 
                                        value={status.id}
                                    >
                                        {status.text}
                                    </MenuItem>
                                ))
                            }
                        </TextField>
                    </Grid>
                    <Grid item xs={2}>
                        <Search
                            color='primary'
                            style={{cursor:'pointer'}}
                            id='orderforwardtool-createdetail-search-button'
                            onClick={handleFilter}
                        />
                    </Grid>
                </Grid>
                <DataGrid
                    style={{height:'60vh',marginTop:20}}
                    alignItems="center"
                    rows={createRows()}
                    columns={columns}
                    pageSize={20}
                    disableSelectionOnClick
                />
            </UniDialog>
            <FullscreenLoading open={loading} />
        </>
    );
}